import * as Sentry from "@sentry/react";

import {
  beforeSend,
  beforeSendTransaction,
  getRelease,
  getReplaysSampleRates,
  getTracesSampleRate,
  isSentryEnabled,
} from "@/lib/sentry";

const replaySampleRates = getReplaysSampleRates();

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_ENVIRONMENT,
  release: getRelease(),

  enabled: isSentryEnabled(),

  tracesSampleRate: getTracesSampleRate(),

  sendDefaultPii: true,

  beforeSend,
  beforeSendTransaction,

  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: true,
      blockAllMedia: false,
      mask: [".sentry-mask", "[data-sentry-mask]"],
      block: [".sentry-block", "[data-sentry-block]"],
    }),

    Sentry.browserTracingIntegration({
      shouldCreateSpanForRequest: (url) => {
        return url.startsWith(window.location.origin);
      },
    }),
  ],

  replaysSessionSampleRate: replaySampleRates.session,
  replaysOnErrorSampleRate: replaySampleRates.error,
});
